     $(document).ready(function(){
       $('.home-slider .slider').slick({
       draggable: true,
        swipeToSlide: true,
        dots: false,
        arrows: true,
        infinite: true,
        speed: 500,
        autoplay: true,
        autoplaySpeed: 3000,
        slidesToShow: 1,
        slidesToScroll: 1,
        cssEase: 'linear',
        pauseOnFocus: false, 
        pauseOnHover: false,
       
      });
       $('.press-logos .slider').slick({
       draggable: true,
        swipeToSlide: true,
        dots: false,
        arrows: false,
        infinite: true,
        autoplay: true,
         speed: 2000,
        autoplaySpeed: 1,
        slidesToShow: 7,
        slidesToScroll: 1,
        cssEase: 'linear',
        // waitForAnimate: false,
        pauseOnFocus: false, 
        pauseOnHover: false,
        
        responsive: [
          {
            breakpoint: 780,
            settings: {
              slidesToShow: 5,
              slidesToScroll: 1,
            }
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
            }
          },
          {
            breakpoint: 400,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
            }
          }
        ]
      });
   $('.product-tabs .tabs-btns').slick({
       draggable: true,
        swipeToSlide: true,
        dots: false,
        arrows: false,
        infinite: false,
        autoplay: false,
        slidesToShow: 4,
        slidesToScroll: 4,
        cssEase: 'linear',
        responsive: [
          {
            breakpoint: 780,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 4,
            }
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 2.4,
              slidesToScroll: 1,
            }
          },
          {
            breakpoint: 400,
            settings: {
              slidesToShow: 2.2,
              slidesToScroll: 1,
            }
          }
        ]
      });
       
    $('.product-slider .slider').slick({
       draggable: true,
        swipeToSlide: true,
        dots: false,
        arrows: true,
        infinite: false,
        speed: 600,
        autoplay: false,
        slidesToShow: 4,
        slidesToScroll: 4,
        cssEase: 'linear',
        responsive: [
          {
            breakpoint: 780,
            
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3,
            }
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 1.5,
              slidesToScroll: 1,
              arrows: false,
            }
          }
        ]
      });
       $('.blog .slider').slick({
       draggable: true,
        swipeToSlide: true,
        dots: false,
        arrows: false,
        infinite: false,
        speed: 600,
        autoplay: false,
        slidesToShow: 3,
        slidesToScroll: 3,
        cssEase: 'linear',
        responsive: [
          {
            breakpoint: 780,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
            }
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 1.5,
              slidesToScroll: 1,
            }
          }
        ]
      });
       $('.Love-ur-curls .slider').slick({
       draggable: true,
        swipeToSlide: true,
        dots: true,
        arrows: false,
        infinite: true,
        speed: 500,
        autoplay: true,
        autoplaySpeed: 3000,
        slidesToShow: 1,
        slidesToScroll: 1,
        cssEase: 'linear',
       
      });

  
       
	
        var li = $(".Shop-By-Category .product-tabs .tabs-btns li");
  
         li.click(function(){
          var target = $(this).data("target");
           $(li).removeClass('active');
           $('.Shop-By-Category .product-tabs .tab-container').removeClass('active');
           $(target).addClass('active')
           $(this).addClass('active')

         });

        
      });


